import React from 'react';

import type { GameDto } from '../../api/types';

import { GameTagsList } from './GameTagsList';

import './GameInfo.css';

type GameInfoProps = {
  game: GameDto;
};

export function GameInfo({ game }: GameInfoProps) {
  const tagNames = game.tags.map((t) => t.name);

  return (
    <div className="game-info">
      <div className="game-info__cover-wrap">
        {game.imageUrl ? (
          <img className="game-info__cover" src={game.imageUrl} alt={game.name} />
        ) : (
          <div className="game-info__cover-placeholder">🎲</div>
        )}
      </div>

      <h1 className="game-info__title">{game.name}</h1>

      <div className="game-info__meta">
        <span className="game-info__meta-item">
          👥 {game.minPlayers}–{game.maxPlayers} игроков
        </span>
        {game.estimatedDuration != null && (
          <span className="game-info__meta-item">
            ⏱ ~{game.estimatedDuration} мин.
          </span>
        )}
      </div>

      {tagNames.length > 0 && (
        <div className="game-info__tags">
          <GameTagsList tags={tagNames} />
        </div>
      )}

      {game.description && (
        <p className="game-info__description">{game.description}</p>
      )}

      {game.gameUrl && (
        <a
          className="game-info__link"
          href={game.gameUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          🔗 Подробнее об игре
        </a>
      )}
    </div>
  );
}
